interface DatePickerProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  error?: string;
  id?: string;
  placeholder?: string;
}

export function DatePicker({
  value,
  onChange,
  label,
  error,
  id,
  placeholder,
}: DatePickerProps) {
  return (
    <div>
      {label && (
        <label
          htmlFor={id}
          className="block text-sm font-medium text-content-muted"
        >
          {label}
        </label>
      )}
      <input
        type="date"
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`mt-1 block w-full px-3 py-2 border rounded-md shadow-sm placeholder-content-subtle focus:outline-none focus:ring-primary focus:border-primary sm:text-sm ${
          error
            ? 'border-danger/40 text-danger focus:ring-danger focus:border-danger'
            : 'border-border-strong'
        }`}
      />
      {error && <p className="mt-1 text-sm text-danger">{error}</p>}
    </div>
  );
}
